import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { SpeedCmsCover } from "@/components/organisms/SpeedCmsCover";
import { SpeedCmsFeatures } from "@/components/organisms/SpeedCmsFeatures";
import { SpeedCmsIntro } from "@/components/organisms/SpeedCmsIntro";
import { SpeedCmsPoints } from "@/components/organisms/SpeedCmsPoints";
import { SpeedCmsSpec } from "@/components/organisms/SpeedCmsSpec";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";

export default function ProductSpeedCMSPage(props) {
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"SpeedCMS スピードシーエムエス"}
        pageDescription={
          "株式会社トッカシステムズのSpeedCMSです。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/product/speedcms/"}
      />
      <Layout className="bg-gray-50">
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Product",
                  path: "/product/",
                },
                {
                  name: "SpeedCMS",
                },
              ]}
            />
            <Inner className="max-w-full pt-0 md:pt-5">
              <SpeedCmsCover className="max-w-7xl" />
              <SpeedCmsIntro className="p-6 md:px-14" />
              <div className="mx-auto box-border flex max-w-7xl flex-col items-start gap-4 bg-white py-8 px-6 sm:px-8 md:grid-cols-2 md:gap-12 md:px-12 md:py-16">
                <SpeedCmsFeatures />
                <SpeedCmsPoints />
                <SpeedCmsSpec />
              </div>
            </Inner>
          </Container>
        </main>
        <Contact>
          SpeedCMSはあなたのビジネスに役立てることができるツールです。
          <br />
          まずはお気軽にお問い合わせください。
        </Contact>
        <Careers />
        <Footer />
      </Layout>
    </>
  );
}
